import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, TicketStatus, TicketViewModel } from '../../../models';
import { IAuthentication } from '../../../services';

class TicketListController implements angular.IComponentController {
    authentication: IAuthentication;
    isLoading: boolean;
    loadingMessage: string;
    selectedTicketViewModel: TicketViewModel;
    sortedTicketViewModelList: TicketViewModel[];
    ticketStatus: TicketStatus;
    ticketStatusList: TicketStatus[];
    ticketViewModelList: TicketViewModel[];

    static $inject = [];

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['ticketViewModelList'] && changesObj['ticketViewModelList'].currentValue && this.ticketStatus) {
            const ticketViewModelList = changesObj['ticketViewModelList'].currentValue as TicketViewModel[];
            this.filterTickets(ticketViewModelList, this.ticketStatus);
        }
        if (changesObj['ticketStatus'] && changesObj['ticketStatus'].currentValue && this.ticketViewModelList && this.ticketViewModelList.length > 0) {
            const ticketStatus = changesObj['ticketStatus'].currentValue;
            this.filterTickets(this.ticketViewModelList, ticketStatus);
        }
    }

    filterTickets(ticketViewModelList: TicketViewModel[], ticketStatus: TicketStatus): void {
        const filteredTicketViewModelList = _.filter(ticketViewModelList, ticketViewModel => ticketViewModel.model.statusId === ticketStatus.id);
        this.sortedTicketViewModelList = _.sortBy(filteredTicketViewModelList, ticketViewModel => {
            if (!ticketViewModel) {
                return 0;
            } else if (ticketViewModel && ticketViewModel.model.revisedDueDate) {
                return ticketViewModel.model.revisedDueDate;
            } else if (ticketViewModel && ticketViewModel.model.dueDate) {
                return ticketViewModel.model.dueDate;
            } else {
                return ticketViewModel.model.id;
            }
        });
    }

    // Create new action item (Ticket with a parentId)
    createNew() {
        this.selectedTicketViewModel = null;
        $('#search-ticket-modal').modal('show');
    }
}

export const wtTicketList: ComponentDefinition = {
    componentId: 'wtTicketList',
    controller: TicketListController,
    template: require('./ticketList.component.html'),
    controllerAs: 'vm',
    bindings: {
        authentication: '<',
        currentUserGuid: '<?',
        ticketStatus: '<',
        ticketViewModelList: '<',
        ticketStatusList: '<',
        selectedTicketViewModel: '=',
        saveTicket: '&?'
    }
};
